import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=bda30f6a&scoped=true"
import script from "./BannerItem.vue?vue&type=script&lang=js"
export * from "./BannerItem.vue?vue&type=script&lang=js"
import style0 from "./BannerItem.vue?vue&type=style&index=0&id=bda30f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda30f6a",
  null
  
)

export default component.exports